import React, {useEffect, useState} from 'react';
import styles from "../styles/tabs.module.scss";
import classNames from "classnames";
import {Tab} from "./tab";
import {ListItemViewModel} from "../../../../infrastructure/models/list-item.view-model";

export const Tabs = ({tabs, onTabChange, initialIndex, className, tabClassName, activeTabClassName}) => {
  const [activeIndex, setActiveIndex] = useState(initialIndex);

  useEffect(() => {
    setActiveIndex(initialIndex);
  }, [initialIndex]);

  const onTabClick = (tab) => {
    setActiveIndex(tab.index);

    onTabChange && onTabChange(tab);
  };

  return (
      <div className={classNames(styles.container, className)}>
        {
          tabs.map((tab: ListItemViewModel) => <Tab
                  key={tab.index}
                  tab={tab}
                  isActive={tab.index === activeIndex}
                  onClick={onTabClick}
                  className={tabClassName}
                  activeClassName={activeTabClassName}
              />
          )
        }
      </div>
  )
}
